import React from 'react';
import CustomerContactInfoComp from './CustomerContactInfoComp';

const CustomerContactInfoZipCode = props =>
  (
<CustomerContactInfoComp
  {...props}
  autoComplete="postal-code"
  errorMessages={{
    'field_is_required': 'The postal code field is required',
    'field_is_invalid': 'Your postal code is invalid',
  }}
  label="Postal code"
  name="zipCode"
/>
  );

export default CustomerContactInfoZipCode;
